export enum EEnvironment {
  DEV = 'development',
  STAGE = 'stage',
  PROD = 'production'
}
